import { render, staticRenderFns } from "./CreateTicketByTech.vue?vue&type=template&id=fd196f8a&"
import script from "./CreateTicketByTech.vue?vue&type=script&lang=js&"
export * from "./CreateTicketByTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports